import {createSelector} from 'reselect';

import {UserPageState} from './searchesSlice';

const selectSearchesState = (state: UserPageState) => state.userPage.tabs.content.searches;

export const makeSelectSearchesByUserId = (userId: number) =>
    createSelector(
        [selectSearchesState],
        searchesState => {
            const userSearches = searchesState.countsByUserId[userId];
            return userSearches || {
                total: 0,
                status: 'idle' as const,
                error: undefined,
                receivedAt: undefined,
            };
        },
    );

export const selectSearchesReceivedAt = (state: UserPageState, userId: number) => {
    const userSearches = state.userPage.tabs.content.searches.countsByUserId[userId];
    return userSearches?.receivedAt;
};
